export default {"src":"/_next/static/media/elec.dee9f5d3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};